import React, {useState} from 'react'
import {KTSVG} from '../../helpers'
import {helpArticles} from '../../pages/Help/data/helpArticles'
import {HelpArticleModal} from '../../pages/Help/components/HelpArticleModal'

const HelpIcon = ({articleId}) => {
  const [open, setOpen] = useState(false)
  const article = helpArticles.find((a) => a.id === articleId) ?? null

  if (!article) return null

  return (
    <>
      <button
        type='button'
        className='btn btn-icon btn-sm btn-light-primary ms-2 mt-2'
        title='Yardım'
        onClick={() => setOpen(true)}
      >
        <KTSVG path='/images/icons/nav/Help.svg' className='svg-icon-2' />
      </button>
      <HelpArticleModal article={open ? article : null} onClose={() => setOpen(false)} />
    </>
  )
}

export {HelpIcon}
